import React from 'react';
import { useApp } from '../../context/AppContext';

const OrganizationSelector = ({ className = '' }) => {
    const {
        selectedOrg,
        setSelectedOrg,
        setSelectedFarm,
        orgList,
        user
    } = useApp();

    if (user?.role === 'admin') return null;

    return (
        <select
            value={selectedOrg}
            onChange={(e) => {
                setSelectedOrg(e.target.value);
                setSelectedFarm(null);
            }}
            className={`${className} p-2 border rounded-md bg-white border-r-8 border-transparent`}
        >
            <option value="">All Organizations</option>
            {orgList.map(org => (
                <option key={org.id} value={org.id}>{org.name}</option>
            ))}
        </select>
    );
};

export default OrganizationSelector; 